// extracted by mini-css-extract-plugin
export default {"root":"D6ocvWSZTPblDTybEcA_","footer":"rqBl7yYUOBd3nnSfGjHH","buttonLink":"OrznQ1enIv0mVxMnAfS3"};